var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "men_5"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5ABCBB"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.394c-4.964-9.396-36.875-15.292-36.875-15.292s-31.91,5.896-36.874,15.292 C31.957,128.433,28.888,145,28.888,145h43.611h43.612C116.112,145,114.04,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.499,100.102c0,0,31.911,5.896,36.875,15.292c4.665,11.842,6.737,29.606,6.737,29.606H72.499 V100.102z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.374,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.499,
    y: 81,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.474c1.563,4.485,7.868,7.057,12.499,7.057 c1.676,0,3.306-0.281,4.875-0.795V81H63.813V94.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.837,62.653c0-18.162-10.001-28.489-22.338-28.489c-12.336,0-22.337,10.327-22.337,28.489 c0,24.428,10.001,32.886,22.337,32.886C84.837,95.539,94.837,86.063,94.837,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.837,62.653c0-18.162-10.001-28.489-22.338-28.489c-12.336,0-22.337,10.327-22.337,28.489 c0,24.428,10.001,32.886,22.337,32.886C84.837,95.539,94.837,86.063,94.837,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.161,67.031c-0.684-4.957,2.046-9.318,6.092-9.74c4.053-0.422,7.888,3.259,8.567,8.216 c0.683,4.953-2.053,9.315-6.1,9.739C49.671,75.665,45.84,71.988,45.161,67.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.837,62.653c0-18.162-10.001-28.489-22.338-28.489v61.375 C84.837,95.539,94.837,86.063,94.837,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102F41"
    },
    d: "M109.374,115.394c-3.181-6.021-17.418-10.601-27.242-13.117 c-0.382,4.99-4.545,8.923-9.633,8.923c-5.088,0-9.25-3.933-9.632-8.923c-9.824,2.516-24.061,7.096-27.242,13.117 C31.957,128.433,28.888,145,28.888,145h43.611h43.612C116.112,145,114.04,127.236,109.374,115.394z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M53.941,84.27c4.859,8.252,9.698,9.528,9.698,9.528l1.466,4.755H63h-1.65l-0.915-2.051H58.42 l-0.733-2.517l-1.996,0.839l-0.475-2.797h-1.833l-0.641-2.331l-1.374,0.653l-1.374-2.145l-1.923-1.025l0.916-3.17h-2.289 l0.092-3.357l-1.741,0.56l-0.641-2.983l-2.931-1.119l2.564-2.611l-1.282-0.466l1.373-2.423l-1.007-0.466l-0.184-2.891l-2.93-0.559 l1.649-2.611l-2.016-3.17l2.382-1.306l-1.282-3.169l0.732-2.984l-2.747-2.238l3.846-0.372v-2.797l1.1-2.424l-1.1-2.051 l2.016-1.678l-2.016-1.679l2.198-2.238v-1.305l2.016-1.678l-0.916-2.611l3.662,0.746l0.184-4.475l2.748,0.932l0.915-1.864 l3.114,0.373c0,0-0.732-1.492,0.549-1.492c1.282,0,4.397,1.306,4.397,1.306l1.648-2.238l3.663,2.611l1.283-2.611l2.381,2.797 l2.234-2.797c0,0,0,15.664,0,25.36c-2.895-0.248-4.433-0.248-10.782-2.735c-2.197,1.492-9.28,11.686-9.28,12.68 s-1.222,11.189-1.222,11.189l-1.274-6.08C50.093,67.081,51.363,79.891,53.941,84.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M90.629,84.27c-4.669,8.252-9.318,9.528-9.318,9.528l-1.408,4.755h2.022h1.585l0.88-2.051h1.937 l0.703-2.517l1.919,0.839l0.457-2.797h1.761l0.615-2.331l1.32,0.653l1.32-2.145l1.848-1.025l-0.88-3.17h2.199l-0.088-3.357 l1.673,0.56l0.615-2.983l2.816-1.119l-2.465-2.611l1.233-0.466l-1.32-2.423l0.968-0.466l0.177-2.891l2.814-0.559l-1.584-2.611 l1.937-3.17l-2.288-1.306l1.231-3.169l-0.703-2.984l2.64-2.238l-3.695-0.372v-2.797l-1.057-2.424l1.057-2.051l-1.937-1.678 l1.937-1.679l-2.112-2.238v-1.305l-1.936-1.678l0.881-2.611l-3.52,0.746l-0.177-4.475l-2.64,0.932l-0.88-1.864l-2.992,0.373 c0,0,0.704-1.492-0.527-1.492c-1.232,0-4.225,1.306-4.225,1.306l-1.584-2.238l-3.52,2.611l-1.232-2.611l-2.288,2.797l-2.146-2.797 c0,0,0,15.664,0,25.36c2.78-0.248,4.259-0.248,10.359-2.735c2.112,1.492,8.917,11.686,8.917,12.68s1.174,11.189,1.174,11.189 l1.225-6.08C94.327,67.081,93.107,79.891,90.629,84.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.161,67.031c-0.684-4.957,2.046-9.318,6.092-9.74c4.053-0.422,7.888,3.259,8.567,8.216 c0.683,4.953-2.053,9.315-6.1,9.739C49.671,75.665,45.84,71.988,45.161,67.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.438,75.246c-4.05-0.424-6.783-4.787-6.098-9.739c0.677-4.957,4.513-8.638,8.563-8.216 c4.047,0.422,6.777,4.783,6.094,9.74C99.318,71.988,95.487,75.665,91.438,75.246z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6525a5ef7a6ba2a3cdf5473fb0dc954e.svg";
export { ForwardRef as ReactComponent };